export default __webpack_public_path__ + "static/media/Raywood.1c0352ed.png";